module.exports = __webpack_public_path__ + "static/media/slide2.b032a6db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/slides/slide2.jpg
// module id = 144
// module chunks = 0